import { render, staticRenderFns } from "./DeleteDocumentsModal.vue?vue&type=template&id=7a52cd83&scoped=true&"
import script from "./DeleteDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./DeleteDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteDocumentsModal.vue?vue&type=style&index=0&id=7a52cd83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a52cd83",
  null
  
)

export default component.exports